import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.851 1.33a.667.667 0 0 0-.667.667v3.64l-.666.446V1.997a.667.667 0 1 0-1.334 0v4.086l-.666-.446v-3.64a.667.667 0 0 0-1.334 0v4a.67.67 0 0 0 .3.553l1.7 1.14v6.307a.667.667 0 1 0 1.334 0V7.69l1.7-1.14a.67.67 0 0 0 .3-.553v-4a.667.667 0 0 0-.667-.667m-6.667 0a3.333 3.333 0 0 0-3.333 3.333v4a.667.667 0 0 0 .667.667h2v4.667a.667.667 0 1 0 1.333 0v-12a.667.667 0 0 0-.667-.667m-.666 6.667H4.184V4.663a2 2 0 0 1 1.334-1.886z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })